export const countryConstants = ['USA', 'US'];

export const unknownProvider = {
	NAME: 'unknown provider',
	ID: 20000,
};
